import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import handleRelationshipOptions from './utils/handleRelationshipOptions';
import handleRolesOptions from './utils/handleRolesOptions';
import { loggedUserCountrySelector } from '../../../redux/context/selectors';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';

const mapStateToProps = state => ({
  loggedUserCountry: loggedUserCountrySelector(state),
});

const mapDispatchToProps = {};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ intl: { formatMessage }, formState }) => {
    return {
      formatMessage,
      roleOptions: handleRolesOptions(formatMessage),
      relationshipOptions: handleRelationshipOptions(
        formState[PROFILE_FIELDS_TYPES.ROLE],
        formatMessage,
      ),
    };
  }),
);



// WEBPACK FOOTER //
// ./src/components/common/FieldsList/enhance.js